/**
 * @description: 充值管理路由文件
 * @author: lx
 * @Compile：2023-08-02 14：00
 * @update: lx(2023-08-02 14：00)
 */
export default [
  // 充值奖品管理
  {
    path: '/payPrize',
    component: resolve => require(['../../pages/pages_ports_v3/payManage/payPrizeManage/payPrizeManage.vue'], resolve),
    name: 'payPrize',
    title: "充值奖品管理",
    meta: {
      title: "充值奖品管理"
    }
  },
  // 充值奖品规则管理
  {
    path: '/payPrizeRule',
    component: resolve => require(['../../pages/pages_ports_v3/payManage/payPrizeRuleManage/payPrizeRuleManage.vue'], resolve),
    name: 'payPrizeRule',
    title: "充值奖品规则管理",
    meta: {
      title: "充值奖品规则管理"
    }
  },
  // 充值奖品发放记录
  {
    path: '/payPrizeRecords',
    component: resolve => require(['../../pages/pages_ports_v3/payManage/payPrizeRecords/payPrizeRecords.vue'], resolve),
    name: 'payPrizeRecords',
    title: "充值奖品发放记录",
    meta: {
      title: "充值奖品发放记录"
    }
  },
];
